export const getBrandSearchText = (state) =>
  state.retailerStartOrderModal.brandSearchText
export const getBrandId = (state) => state.retailerStartOrderModal.brandId
export const getCollectionSearchText = (state) =>
  state.retailerStartOrderModal.collectionSearchText
